import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import DefaultImage from "../assets/images/logo-small.png";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import OtherService from "../services/Other";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import useScrollToTop from "../hooks/useScrollToTop";
import NoData from "../component/NoData";
import { useSelector } from "react-redux";
const CategoryList = () => {
  useScrollToTop()
  const navigate = useNavigate();
  //All States
  const [loading, setLoading] = useState(true);

  const userData =  useSelector(
    state => state.userTypeSlice.userData,
);
  const isCategoryList = useSelector(
    state => state.userTypeSlice.productCategory,
);

  const downloadAndSavePDF = () => {
    const token = localStorage.getItem("access_token");
    
    OtherService.downloadProductPDF(token)
      .then(async (res) => {
        const bes64Dataa = res.data;
        //    alert(JSON.stringify(res))
        pdfCreate(bes64Dataa);
      })
      .catch((err) => {
        // setpdfLoadingst(false);
      });
  };

  //UseEffects
  useEffect(() => {
    if (isCategoryList.length > 0) {
      setLoading(false);
    }
  }, [isCategoryList]);
  const pdfCreate = (bes64Dataa) => {
    const d = new Date();
    let time = d.getTime();
    const linkSource = `data:application/pdf;base64,${bes64Dataa}`;
    const downloadLink = document.createElement("a");
    const fileName = "my_pdf" + time + ".pdf"; // Set your desired file name here
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  //Function
  const handleShowProduct = (catgryId) => {
    if(userData?.document_exist == '1') {
      navigate(`/rewards-category-list/${catgryId}`);
    } else {
      navigate('/dynamic-ekyc', { state: catgryId })
    }
  };


  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion
        pageTitle="Rewards Category List"
        currentPageName="Rewards Category List"
      />
      <section className="padTop50">
        <Container>
          <Row>
            <Col>
              <div className="categoryList">
                {/* <div className="row justify-content-end">
                  <div className="col-auto">
                    <PrimaryGradientButton
                      buttonText="Download PDF"
                      className="mb-3"
                      onClick={downloadAndSavePDF}
                    />
                  </div>
                </div> */}
                {isCategoryList.length == 0 && !loading && <NoData title="No rewards available" />}
                <ul>
                  {isCategoryList?.map((item) => {
                    const { catgryId, catgryName, catgryImg } = item;
                    return (
                      <div className="categoryListitem" key={catgryId}>
                        <li
                          onClick={() => {
                            handleShowProduct(catgryId,catgryName);
                          }}
                        >
                          <Link>
                            <div className="categoryListBoxWrap">
                              <div className="categoryListBox">
                                {catgryImg !== null ? (
                                  <img src={catgryImg} alt={catgryName} />
                                ) : (
                                  <img src={DefaultImage} alt={catgryName} />
                                )}
                              </div>
                            </div>
                            <p>{catgryName}</p>
                          </Link>
                        </li>
                      </div>
                    );
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CategoryList;
